import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Pages
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import APITestPage from "./pages/APITestPage";

// Components
import ProtectedRoute from "./components/auth/ProtectedRoute";
import PublicEstablishmentsList from "./components/publico/PublicEstablishmentsList";
import EstablishmentDetail from "./components/publico/EstablishmentDetail";
import GraciasReserva from "./components/GraciasReserva";
import ReservaSearchPage from "./pages/ReservaSearchPage"; // ⬅️ NUEVO

// Componente para manejar redirección automática
const AppRoutes = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando aplicación...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Rutas públicas */}
      <Route
        path="/login"
        element={
          isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />
        }
      />
      <Route
        path="/register"
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <RegisterPage />
          )
        }
      />
      {/* Página de búsqueda y filtro de canchas */}
      <Route path="/reservar" element={<ReservaSearchPage />} />{" "}
      {/* ⬅️ NUEVO */}
      {/* Página de pruebas de API */}
      <Route path="/test-api" element={<APITestPage />} />
      {/* Rutas protegidas */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      {/* Página de no autorizado */}
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      {/* Página de éxito tras pago MercadoPago */}
      <Route path="/gracias" element={<GraciasReserva />} />
      {/* Detalle público de establecimiento y sus canchas */}
      <Route path="/establecimientos/:id" element={<EstablishmentDetail />} />
      {/* Redirección por defecto */}
      <Route path="/" element={<HomePage />} />
      {/* Ruta catch-all para páginas no encontradas */}
      <Route
        path="*"
        element={
          <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center">
              <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
              <p className="text-gray-600 mb-4">Página no encontrada</p>
              <Navigate to="/" replace />
            </div>
          </div>
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <div className="App">
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
